import { createSelector } from 'reselect'
import getUserFullName from './getUserFullName'


const getUserFullNameFromState = createSelector<ReduxState, string, string, string>(
  (state) => state.models.me.firstName,
  (state) => state.models.me.lastName,
  (firstName, lastName) => getUserFullName({ firstName, lastName })
)


export default getUserFullNameFromState
